@use "Styles/mixins";
@use "Styles/includes/variables";

:host {
    .vm-profile-image {
        position: relative;
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 100%;
        overflow: hidden;
        margin: 0;
        aspect-ratio: 1 / 1;

        img {
            display: block;
            width: 100%;
            height: 100%;
            margin: 0;
            object-position: top;
        }

        a {
            position: absolute;
            inset: 0;
            z-index: 1;
        }

        &--initials {
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: variables.$fontQuaternary;
            font-size: 24px;
            background-color: mixins.get-color(background, bg-gray-100);
            color: mixins.get-color(text, text-white);
            font-weight: 700;

            @include mixins.min-screen(variables.$md) {
                font-size: 30px;
            }
        }
    }
}

:host([data-color-index="1"]) .vm-profile-image--initials {
    background-color: mixins.get-color(background, bg-brand-teal);
}
:host([data-color-index="2"]) .vm-profile-image--initials {
    background-color: mixins.get-color(background, bg-brand-gold);
}
:host([data-color-index="3"]) .vm-profile-image--initials {
    background-color: mixins.get-color(background, bg-brand-lavender);
}
:host([data-color-index="4"]) .vm-profile-image--initials {
    background-color: mixins.get-color(background, bg-brand-sage);
}
:host([data-color-index="5"]) .vm-profile-image--initials {
    background-color: mixins.get-color(background, bg-brand-sky);
}

:host([fit="fill"]) img {
    object-fit: fill;
}
:host([fit="cover"]) img {
    object-fit: cover;
}
:host([fit="contain"]) img {
    object-fit: contain;
}
:host([fit="none"]) img {
    object-fit: none;
}
:host([fit="scale-down"]) img {
    object-fit: scale-down;
}
